import React, { CSSProperties, useEffect, useState } from 'react';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  TextField,
  Typography
} from '@mui/material';
import {
  bookingsServices,
  customerStyle,
  useStyles
} from 'src/theme/vemigoCustomStyles/VemigoCustomStyles';
import VemigoTextFeild from 'src/components/VemigoGrid/VemigoTextFeild';
import { useCustomerData } from '../../customer/customerData';
import { useCustomerBookingCart } from '../../customer/selectedCustomerData';
import { CustomerBookingServicess } from 'src/services/customer/bookingServices';
import { enqueueSnackbar } from 'notistack';
import { CustomerCartServicess } from 'src/services/customer/customerCartServices';
import { NavLink as RouterLink, useNavigate } from 'react-router-dom';

const style: { [key: string]: CSSProperties } = {
  tableHeaders: {
    textAlign: 'left',
    padding: '8px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  tableData: {
    padding: '8px',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
}

const renderPackages = (data) => {

  return (
    <div
      style={{
        width: '100%',
        minHeight: '10vh',
        maxHeight: '30vh',
        borderRadius: '6px',
        margin: '2vh 0px',
        marginLeft: '20px',
        padding: '1rem',
        overflowY: 'auto',
        boxShadow: '0 0 3px rgba(0, 0, 0, 0.3)'
      }}
    >
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th
              style={style.tableHeaders}
            >
              Package Name
            </th>
            <th
              style={style.tableHeaders}
            >
              Price
            </th>
            <th
              style={style.tableHeaders}
            >
              Discount
            </th>
            <th
              style={style.tableHeaders}
            >
              Tax
            </th>
            <th
              style={style.tableHeaders}
            >
              Amount
            </th>
            <th
              style={style.tableHeaders}
            >
              Start Date
            </th>
            <th
              style={style.tableHeaders}
            >
              End Date
            </th>
            <th
              style={style.tableHeaders}
            >
              Preferred TimeSlot
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => {
            return (
              <tr key={index} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td
                  style={style.tableData}
                >
                  {item?.package?.name}
                </td>
                <td
                  style={style.tableData}
                >
                  {item.price}
                </td>
                <td
                  style={style.tableData}
                >
                  {item.discountAmount}
                </td>
                <td
                  style={style.tableData}
                >
                  {item.taxAmount}
                </td>
                <td
                  style={style.tableData}
                >
                  {item.finalAmount}
                </td>
                <td
                  style={style.tableData}
                >
                  {new Date(item.startDate).toDateString()}
                </td>
                <td
                  style={style.tableData}
                >
                  {new Date(item.endDate).toDateString()}
                </td>
                <td
                  style={style.tableData}
                >
                  {item.preferredTimeSlot}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

const renderServices = (data) => {
  const {allTimeSlots } = useCustomerData();
  return (
    <div
      style={{
        width: '100%',
        minHeight: '10vh',
        maxHeight: '30vh',
        borderRadius: '6px',
        margin: '2vh 0px',
        marginLeft: '20px',
        padding: '1rem',
        overflowY: 'auto',
        boxShadow: '0 0 3px rgba(0, 0, 0, 0.3)'
      }}
    >
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th
              style={style.tableHeaders}
            >
              Service Name
            </th>
            <th
              style={style.tableHeaders}
            >
              Price
            </th>
            <th
              style={style.tableHeaders}
            >
              Discount
            </th>
            <th
              style={style.tableHeaders}
            >
              Tax
            </th>
            <th
              style={style.tableHeaders}
            >
              Amount
            </th>
            <th
              style={style.tableHeaders}
            >
              Date
            </th>
            <th
              style={style.tableHeaders}
            >
              Time Slot
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => {
            return (
              <tr key={index} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td
                  style={style.tableData}
                >
                  {item.serviceName}
                </td>
                <td
                  style={style.tableData}
                >
                  {item.price}
                </td>
                <td
                  style={style.tableData}
                >
                  {item.discountAmount}
                </td>
                <td
                  style={style.tableData}
                >
                  {item.taxAmount}
                </td>
                <td
                  style={style.tableData}
                >
                  {item.finalAmount}
                </td>
                <td
                  style={style.tableData}
                >
                  {new Date(item.date).toLocaleDateString('en-GB')}
                </td>
                <td
                  style={style.tableData}
                >
                  {allTimeSlots?.find((x) => x.id === item.timeSlotId)?.startTime}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

const renderAddress = (data) => {
  const { customerAddressTypes, allCities, allAreas } = useCustomerData();

  const cityName =
    allCities?.find((x) => x.id === data[0]?.address?.cityID)?.name || 'N/A';

  const areaName =
    allAreas?.find((x) => x.id === data[0]?.address?.areaID)?.name || 'N/A';

  const addressType =
    customerAddressTypes.find(
      (t) => t.id === data[0]?.address?.customerAddressTypeId
    )?.name || 'N/A';

  const mobile =
    data[0]?.address?.mobileNumber ??
    data[0]?.address?.contactNumber1 ??
    data[0]?.address?.contactNumber2 ??
    'N/A';

  return (
    <div style={bookingsServices.actServicesStyle.addTabCointainer}>
      <Typography variant="h4" style={useStyles.formTitle}>
        Address
      </Typography>
      <Divider sx={customerStyle.divider} />

      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12} md={3}>
          <Typography>
            {cityName} - {areaName}
          </Typography>
        </Grid>

        <Grid item xs={12} md={2}>
          <Typography>{addressType}</Typography>
        </Grid>

        <Grid item xs={12} md={5}>
          <Typography
            sx={{
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              overflowWrap: 'anywhere'
            }}
          >
            {data[0]?.address?.addressLine1}
          </Typography>
        </Grid>

        <Grid item xs={12} md={2}>
          <Typography>{mobile}</Typography>
        </Grid>
      </Grid>
    </div>
  );
};


export const OrderSummary = (props) => {
  const { allCities, allAreas, allCars, allStatuses } = useCustomerData();
  const {
    subscriptionCards,
    selectedCustomerData,
    CartId,
    handleGetCartSubscriptions,
    setCartId,
    cart,
    cartCardsData,
    handleGetCartData,
    setOpenAddBookingPage,
    setSubscriptionCards,
    refreshBookingList
  } = useCustomerBookingCart();
  const { handleClose, cityId, areaId, paymentDetails, page, onBack } = props;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)

  const handleDeleteCart = async () => {
    const updatedCart = await CustomerCartServicess.getById(CartId);
    try {
      if (page === 'Subscription') {
        if (!updatedCart.cartServices || updatedCart.cartServices.length === 0) {
          await CustomerCartServicess.deleteData(CartId);
          setCartId(0);


        } else {
          await Promise.all(
            subscriptionCards.map((sub) =>
              CustomerCartServicess.removeSubscriptionFromCart(sub.cartSubscriptionId)
            )
          );


          const refreshedCart = await CustomerCartServicess.getById(CartId);

          const isCartEmpty =
            (!refreshedCart.cartServices || refreshedCart.cartServices.length === 0) &&
            (!refreshedCart.cartSubscriptions || refreshedCart.cartSubscriptions.length === 0);

          if (isCartEmpty) {
            await CustomerCartServicess.deleteData(CartId);

            setCartId(0);
          }
        } handleGetCartSubscriptions('Get');
      } else if (page === 'Booking') {

        if (!updatedCart.cartSubscriptions || updatedCart.cartSubscriptions.length === 0) {

          await CustomerCartServicess.deleteData(CartId);

          setCartId(0);
        } else {
          const servicesToRemove = cartCardsData[0]?.services || [];

          await Promise.all(
            servicesToRemove.map((service: any) =>
              CustomerCartServicess.removeServiceFromCart(service.cartServiceId)
            )
          );

          const refreshedCart = await CustomerCartServicess.getById(CartId);

          const isCartEmpty =
            (!refreshedCart.cartServices || refreshedCart.cartServices.length === 0) &&
            (!refreshedCart.cartSubscriptions || refreshedCart.cartSubscriptions.length === 0);

          if (isCartEmpty) {
            await CustomerCartServicess.deleteData(CartId);

            setCartId(0);
          }
        }
        handleGetCartData('Get');
      }

    } catch (error) {
      console.error(' Error deleting cart:', error);
    }
  };

  const handleAddBooking = async () => {
    setLoading(true);
    const transformedSubscriptions = subscriptionCards.map((card) => {
      return {
        id: 0,
        customerCarId: card.car.customerCarId,
        areaId: areaId,
        customerAddressId: card.address.addressId,
        cityId: cityId,
        packageId: card.packageId,
        startDate: card.startDate,
        endDate: card.endDate,
        price: card.price,
        preferredTimeSlotId:card.preferredTimeSlotId,
        taxRate: card.taxRate,
        taxAmount: card.taxAmount,
        discountRate: card.discountRate,
        discountAmount: card.discountAmount,
        finalAmount: card.finalAmount,
        note: card.note || '',
        autoRenew: true
      };
    });
    const reqModel = {
      id: 0,
      customerId: selectedCustomerData.id,
      cityId: cityId,
      serviceOrders: [],
      subscriptions: transformedSubscriptions,
      createdById: 0,
      paymentMethodId: paymentDetails.paymentMethod ? 1 : 0,
      paymentDetails: paymentDetails.paymentDetails,
      note: paymentDetails.note,
      roundOff: 0
    };

    try {
      const response = await CustomerBookingServicess.addData(reqModel);

      await handleDeleteCart();
      handleClose();
      setSubscriptionCards([]);
      refreshBookingList();
      navigate("/subscriptions");
    } catch (error) {
      enqueueSnackbar(`Booking created unsuccessfully`, {
        variant: 'error'
      });
      console.error('Error updating data:', error);
    } finally {
      setLoading(false);
    }
  };

  const newStatus = allStatuses.find(status => status.name === "New");
  const newStatusId = newStatus ? newStatus.id : 30;
  const handleAddServiceOrder = async () => {
    setLoading(true);
    const transformedServices = cartCardsData[0].services.map((card) => {
      return {
        id: 0,
        customerCarId: cartCardsData[0].car.customerCarId,
        areaId: areaId,
        customerAddressId: cartCardsData[0].address.addressId,
        cityId: cityId,
        serviceId: card.serviceId,
        servicePartnerId: null,
        date: card.date,
        timeSlotId: card.timeSlotId,
        currentStatusId: newStatusId,
        price: card.price,
        taxRate: card.taxRate,
        taxAmount: card.taxAmount,
        discountRate: card.discountRate,
        discountAmount: card.discountAmount,
        finalAmount: card.finalAmount,
        note: card.note
      };
    });
    const reqModel = {
      id: 0,
      customerId: selectedCustomerData.id,
      cityId: cityId,
      serviceOrders: transformedServices,
      subscriptions: [],
      createdById: 0,
      paymentMethodId: paymentDetails.paymentMethod ? 1 : 0,
      paymentDetails: paymentDetails.paymentDetails,
      note: paymentDetails.note,
      roundOff: 0
    };
    
    try {
      await CustomerBookingServicess.addData(reqModel);
      await handleDeleteCart();
      setOpenAddBookingPage(false);
      handleClose();
      refreshBookingList();
    } catch (error) {
      enqueueSnackbar(`Booking created unsuccessfully`, {
        variant: 'error'
      });
      console.error('Error updating data:', error);
    } finally {
      setLoading(false);
    }
  };

  const serviceData = page === 'Booking'
    ? (cartCardsData?.[0]?.services || [])
    : subscriptionCards;

  const totalPrice = serviceData.reduce(
    (sum, order) => sum + (order.price || 0),
    0
  );
  const totalDiscount = serviceData.reduce(
    (sum, order) => sum + (order.discountAmount || 0),
    0
  );
  const totalTax = serviceData.reduce(
    (sum, order) => sum + (order.taxAmount || 0),
    0
  );
  const totalAmount = serviceData.reduce(
    (sum, order) => sum + (order.finalAmount || 0),
    0
  );

  const totalServices = serviceData.length;

  const allFields = [
    {
      id: 'customerName',
      title: 'Customer Name',
      size: 4,
      value: `${selectedCustomerData.firstAndMiddleName} ${selectedCustomerData.lastName}`
    },
    {
      id: 'cityId',
      title: 'City & Area',
      size: 4,
      value: `${allCities?.find((s) => s.id === cityId)?.name} - ${allAreas?.find((x) => x.id === areaId)?.name}`
    },
    {
      id: 'carId',
      title: 'Selected Car',
      size: 4,
      value:
        page === 'Booking'
          ? `${allCars?.find((x) => x.id === cartCardsData[0]?.car?.carId)?.brand?.name} - ${allCars?.find((x) => x.id === cartCardsData[0]?.car?.carId)?.name}`
          : `${allCars?.find((x) => x.id === subscriptionCards[0]?.car?.carId)?.brand?.name} - ${allCars?.find((x) => x.id === subscriptionCards[0]?.car?.carId)?.name}`
    }
  ];

  const finalFields = [
    {
      id: 'totalServices',
      title: 'Total Services',
      value: totalServices,
      size: 2.4
    },
    {
      id: 'totalPrice',
      title: 'Total Price',
      value: totalPrice,
      size: 2.4
    },
    {
      id: 'totalDiscount',
      title: 'Total Discount',
      value: totalDiscount,
      size: 2.4
    },
    {
      id: 'totalTax',
      title: 'Total Tax',
      value: totalTax,
      size: 2.4
    },
    {
      id: 'finalAmount',
      title: 'Final Amount',
      value: totalAmount,
      size: 2.4
    }
  ];

  return (
    <>
      <DialogTitle style={useStyles.dialogTitle}>Order Summary</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          {allFields.map((field) => (
            <Grid item xs={field.size} key={field.id}>
              <Typography variant="h5" style={useStyles.formTitle}>
                {field.title}
              </Typography>
              {field.id !== 'empty' && (
                <VemigoTextFeild
                  value={String(field.value)}
                  counter={false}
                  readonly={true}
                />
              )}
            </Grid>
          ))}
          {page === 'Subscription' && renderPackages(subscriptionCards)}
          {page === 'Booking' && renderServices(cartCardsData?.[0].services)}
          {renderAddress(
            page === 'Booking' ? cartCardsData : subscriptionCards
          )}
        </Grid>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '1px',
            padding: '1px'
          }}
        >
          {finalFields.map((field) => (
            <Grid item xs={field.size} key={field.id}>
              <Typography variant="h5" style={useStyles.formTitle}>
                {field.title}
              </Typography>
              <VemigoTextFeild
                value={String(field.value)}
                counter={false}
                readonly={true}
              />
            </Grid>
          ))}
        </Grid>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '1px',
            padding: '1px'
          }}
        >
          <div style={bookingsServices.actServicesStyle.addTabCointainer}>
            <div>
              <Typography variant="h4" style={useStyles.formTitle}>
                Payment Details
              </Typography>
              <Divider sx={customerStyle.divider} />
            </div>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <tbody>
                <tr>
                  <td style={bookingsServices.actServicesStyle.addTabtd}>
                    {paymentDetails.paymentMethod
                      ? 'Will be paid by cash'
                      : 'Paid online'}
                  </td>
                  <td style={bookingsServices.actServicesStyle.addTabtd}>
                    {totalAmount}
                  </td>
                  <td style={bookingsServices.actServicesStyle.addTabtd}>
                    {paymentDetails.paymentDetails || ' '}
                  </td>
                  <td style={bookingsServices.actServicesStyle.addTabtd}>
                    {selectedCustomerData.mobileNumber ??
                      selectedCustomerData.contactNumber1 ??
                      selectedCustomerData.contactNumber2}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Grid>

        <div style={{ marginTop: '2vh' }}>
          <Typography variant="h4" style={useStyles.formTitle}>
            Note
          </Typography>
          <Divider sx={customerStyle.divider} />
          <TextField
            fullWidth
            value={paymentDetails.note}
            placeholder=" "
            variant="outlined"
            style={{ marginTop: '1vh' }}
            aria-readonly={true}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            onBack();
          }}
          disabled={loading}
        >
          Go Back
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={loading}
          onClick={() => {
            page === 'Subscription'
              ? handleAddBooking()
              : handleAddServiceOrder();
          }}
        >
          {loading
            ? 'Processing...'
            : page === 'Subscription'
              ? 'Add Package'
              : 'Add Service'}
        </Button>
      </DialogActions>
    </>
  );
};
